export default "__VITE_ASSET__CZWUOLTt__"